import { AlertCircle, Loader2, RotateCcw, Save } from "lucide-react"

import { Button } from "@/components/ui/button"

export function UnsavedChangesBanner({
  isSaving,
  onDiscard,
  onSave,
}: {
  isSaving: boolean
  onDiscard: () => void
  onSave: () => void
}) {
  return (
    <div className="bg-amber-500 border-b border-amber-600 flex-shrink-0">
      <div className="flex items-center justify-between px-6 py-2.5">
        <div className="flex items-center gap-2">
          <AlertCircle size={16} className="text-white" />
          <span className="text-sm font-medium text-white">You have unsaved changes</span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={onDiscard}
            className="h-7 gap-1.5 text-xs bg-white/10 border-white/30 text-white hover:bg-white/20 font-medium"
          >
            <RotateCcw size={12} />
            Discard
          </Button>
          <Button
            size="sm"
            onClick={onSave}
            disabled={isSaving}
            className="h-7 gap-1.5 text-xs bg-white text-amber-600 hover:bg-palette-jungleGreen000 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? (
              <>
                <Loader2 size={12} className="animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Save size={12} />
                Save Changes
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
